import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';

export interface GeneratePinParams {
	survey_id: string;
	survey_link_id: string;
	employee_code?: string;
	token_survey: string;
}

const Service = PsychosocialReportService.getInstance();

export const useGeneratePin = () => {
	return useMutation({
		mutationFn: (params: GeneratePinParams) => Service.generatePin(params),
		onError: (error: any) => {
			message.error(I18n.get(error?.response?.data?.message || 'Failed to generate PIN'));
		}
	});
};
